let scriptLoaded = false
let scriptLoading = false
const callbacks: Array<() => void> = []

export function loadGoogleMaps(): Promise<void> {
  return new Promise((resolve) => {
    if (scriptLoaded) { resolve(); return }
    callbacks.push(resolve)
    if (scriptLoading) return
    scriptLoading = true

    const key = import.meta.env.VITE_GOOGLE_MAPS_API_KEY as string
    if (!key) {
      scriptLoaded = true
      callbacks.forEach(cb => cb())
      callbacks.length = 0
      return
    }

    const script = document.createElement('script')
    script.src = `https://maps.googleapis.com/maps/api/js?key=${key}&libraries=places`
    script.async = true
    script.onload = () => {
      scriptLoaded = true
      scriptLoading = false
      callbacks.forEach(cb => cb())
      callbacks.length = 0
    }
    script.onerror = () => {
      scriptLoaded = true
      scriptLoading = false
      callbacks.forEach(cb => cb())
      callbacks.length = 0
    }
    try {
      document.head.appendChild(script)
    } catch {
      scriptLoaded = true
      scriptLoading = false
      callbacks.forEach(cb => cb())
      callbacks.length = 0
    }
  })
}

export async function getCityPredictions(input: string): Promise<Array<{ value: string; label: string }>> {
  if (!input.trim()) return []
  await loadGoogleMaps()

  const google = (window as Window & { google?: typeof globalThis.google }).google
  if (!google?.maps?.places) return []

  return new Promise((resolve) => {
    const service = new google.maps.places.AutocompleteService()
    service.getPlacePredictions(
      {
        input,
        types: ['(cities)'],
        componentRestrictions: { country: 'us' },
      },
      (predictions, status) => {
        if (status !== google.maps.places.PlacesServiceStatus.OK || !predictions) {
          resolve([])
          return
        }
        resolve(
          predictions.map(p => ({
            value: p.description,
            label: p.description,
          }))
        )
      },
    )
  })
}

export function parseCityState(description: string): { city: string; state: string } {
  const parts = description.split(',').map(s => s.trim())
  return {
    city: parts[0] ?? '',
    state: parts[1] ?? '',
  }
}
